module.exports = "/static/media/dtmf-hash.4fdf289f.mp3";